import { useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import styles from '../comfirmations.module.scss';
import { AppContext } from '../../../../router/approuter';
import Header from '../../../components/header/header';
import Footer from '../../../components/footer/footer';
import validationImg from '../../../../assets/img/validation_success.png';

export const ConfirmationOk = () => {

    const appContext = useContext(AppContext);
    const [searchParams] = useSearchParams();

    const [talentFirstName, setTalentFirstName] = useState('Sin especificar');

    useEffect(() => {
        let talentFirstName = searchParams.get('talentFirstName');
        if ( talentFirstName ) {
            setTalentFirstName(talentFirstName);
        }
    }, []);

    const renderConfirmation = () => (
        <div className={ styles.confirmations }>
            <div className={ styles.confirmations_container }>
                <span className={ `${styles.confirmations_title} ${styles.confirmations_title_primary}` }>Hola, {talentFirstName}. Valoramos tu compromiso para seguir mejorando.</span>
                <span className={ `${styles.confirmations_text} ${styles.confirmations_text_middle}` }>Continuaremos dándote seguimiento para apoyar tu crecimiento.</span>
            </div>
            <div className={ styles.message_img}>
                { appContext.isDesktopOrLaptop && (<img src={ validationImg } alt="" />) }
            </div>
        </div>
    )

    return (
        <div>
            <Header />
            { renderConfirmation() }
            { appContext.isDesktopOrLaptop && <Footer /> }
        </div>
    )
}
